// NOM-035 — Sistema de tema (claro/oscuro)

export function getTheme(dark) {
  return dark ? {
    bg: "#0f1117",
    bgCard: "#1a1d27",
    bgInput: "rgba(255,255,255,0.04)",
    border: "rgba(255,255,255,0.06)",
    borderInput: "rgba(255,255,255,0.08)",
    textStrong: "#f0f0f0",
    textMuted: "#888",
    textFaint: "#555",
    textLink: "#818cf8",
    accent: "#6366f1",
    accentLight: "rgba(99,102,241,0.12)",
    accentBorder: "rgba(99,102,241,0.25)",
    tagDone: "#10b981",
    tagPending: "#f59e0b",
    alertBg: "rgba(239,68,68,0.08)",
    okBg: "rgba(16,185,129,0.08)",
    sidebar: "#13151d",
    sidebarBorder: "rgba(255,255,255,0.04)",
  } : {
    bg: "#f5f6fa",
    bgCard: "#ffffff",
    bgInput: "#f9fafb",
    border: "#e5e7eb",
    borderInput: "#d1d5db",
    textStrong: "#111827",
    textMuted: "#6b7280",
    textFaint: "#9ca3af",
    textLink: "#4f46e5",
    accent: "#4f46e5",
    accentLight: "rgba(79,70,229,0.06)",
    accentBorder: "rgba(79,70,229,0.2)",
    tagDone: "#059669",
    tagPending: "#d97706",
    alertBg: "rgba(239,68,68,0.06)",
    okBg: "rgba(16,185,129,0.06)",
    sidebar: "#ffffff",
    sidebarBorder: "#e5e7eb",
  };
}
